import { useSyncExternalStore } from 'react';

const BREAKPOINT = 991 as const;

const query = `(max-width: ${BREAKPOINT}px)`;
const mql = typeof window !== 'undefined' ? window.matchMedia(query) : null;

const subscribe = (callback: () => void) => {
  mql?.addEventListener('change', callback);
  return () => mql?.removeEventListener('change', callback);
};

const getSnapshot = () => mql?.matches ?? false;
const getServerSnapshot = () => false;

export const useIsMobile = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
